export const prepareCssValue = (value: string | number, units: string = 'px') =>
  (typeof value === 'string') ? value : `${value}${units}`
